import type { DataErrorRepository, GetIrregularDeltaResult } from '../data/data-error-repository';
import type { DataErrorFilters } from '../types/data-error-types';

export class GetIrregularDeltaUseCase {
  constructor(private readonly repository: DataErrorRepository) {}

  async execute(
    page: number,
    pageSize: number,
    filters: DataErrorFilters
  ): Promise<GetIrregularDeltaResult & { hasError: false } | { hasError: true; errorMessage: string }> {
    try {
      const result = await this.repository.getIrregularDelta(page, pageSize, filters);
      return { ...result, hasError: false };
    } catch (error: unknown) {
      return {
        hasError: true,
        errorMessage: error instanceof Error ? error.message : 'Failed to fetch records',
      };
    }
  }
}
